// extracted by mini-css-extract-plugin
export default {"headerWrapper":"header_headerWrapper__W4Ke+","arrowButton":"header_arrowButton__hc-Tf"};